export const TOOLBAR_LINK_CONSTS = {
    bottomTextModalMsg: '',
    descriptionLabelMsg: 'Ссылка',
    pasteMsg: 'Вставить',
    titleModalMsg: 'Вставка ссылки'
}
